import {ProcessElementProps} from "./ProcessElementProps.js";

export class ProcessLaneProps extends ProcessElementProps {
	constructor(processEditor, fieldPath, obj, member) {
		super(processEditor, fieldPath, obj, member);
	}

	rebuild() {
		super.rebuild();
	}
}